import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConsultaProductSelectorComponent } from './consulta-product-selector.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import {  MatIconModule } from '@angular/material/icon';



@NgModule({
  declarations: [
    ConsultaProductSelectorComponent
  ],
  imports: [
    CommonModule,
    MatFormFieldModule,
    MatSelectModule,
    MatIconModule
  ],
  exports: [
    ConsultaProductSelectorComponent
  ]
})
export class ConsultaProductSelectorModule { }
